import React from 'react'
import './About.css'
import about from '../../assets/frontend_assets/about_img.png'

function About() {
  return (
    <div className='about_container'>
        <div className="about_left">
            <img src={about} alt="" />
        </div>
        <div className="about_right">
            <h2>ABOUT US <hr/></h2>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse eveniet ab temporibus veritatis officia, vitae perferendis illo molestias, pariatur minima, dolor et facilis amet numquam labore expedita eius dolore sapiente.</p>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi blanditiis at perferendis. Maxime nulla id, placeat quisquam commodi excepturi ad modi earum labore magni molestiae consectetur accusantium laboriosam dicta quam.</p>
            <h3>Our Mission</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam mollitia possimus laudantium officiis dolorem delectus odit modi distinctio sed numquam adipisci enim illo, at soluta ab ratione blanditiis iusto quasi.</p>
        </div>
    </div>
  )
}

export default About